import React from 'react'

import { Icon } from '#/components/Icon'
import Colors from '#/styles/Old/Colors'

const HasDataBadge = props => {
  return props.value ? (
    <Icon size="large" name="mui-check" style={{ color: Colors.collar_available }} />
  ) : (
    <Icon size="large" name="help-outline" style={{ color: Colors.collar_revision }} />
  )
}

export default HasDataBadge
